import { Runtime } from '../runtime/Runtime';
import { Keyboard } from './keyboard/Keyboard';

export class Devices {
  readonly parent: Runtime;

  constructor(parent) {
    this.parent = parent;
  }

  readonly keyboard = new Keyboard(this);
}
